"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isQQBrowser = exports.isTBS = exports.isQQMusic = exports.isWeChat = exports.isQzone = exports.isQQ = exports.isIPad = exports.isIOS = exports.isAndroid = void 0;
var isAndroid = function (userAgent) { return /Android/i.test(userAgent); };
exports.isAndroid = isAndroid;
var isIOS = function (userAgent) { return /iPhone/i.test(userAgent); };
exports.isIOS = isIOS;
var isIPad = function (userAgent) { return /iPad/i.test(userAgent); };
exports.isIPad = isIPad;
var isQQ = function (userAgent) { return / QQ\//i.test(userAgent); };
exports.isQQ = isQQ;
var isQzone = function (userAgent) { return / Qzone\//i.test(userAgent); };
exports.isQzone = isQzone;
var isWeChat = function (userAgent) { return / MicroMessenger\//i.test(userAgent); };
exports.isWeChat = isWeChat;
var isQQMusic = function (userAgent) { return / QQMusic\//i.test(userAgent); };
exports.isQQMusic = isQQMusic;
var isTBS = function (userAgent) { return / TBS\//i.test(userAgent); };
exports.isTBS = isTBS;
var isQQBrowser = function (userAgent) { return !exports.isTBS(userAgent) && / MQQBrowser\//i.test(userAgent) || / QBWebViewType\//i.test(userAgent) && !exports.isQQ(userAgent); };
exports.isQQBrowser = isQQBrowser;
//# sourceMappingURL=ua.js.map